import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import usePaymentAuthorizationStats from 'hooks/usePaymentAuthorizationStats';
import { formatUsdCurrency } from 'utils/formatUsdCurrency';

const PaymentStats = () => {
  const { data: stats, isLoading } = usePaymentAuthorizationStats();

  const tiles = [
    {
      label: 'Total Auths Held',
      value: formatUsdCurrency(stats?.totalAuthsHeldAmount ?? 0),
      subtext: `${stats?.activeHoldsCount ?? 0} active holds`,
    },
    {
      label: 'Appointments Auths Held',
      value: stats?.upcomingHoldAuth ?? 0,
      subtext: 'Upcoming appts',
    },
    {
      label: 'Shows',
      value: stats?.showsCount ?? 0,
      subtext: 'Card released',
    },
    {
      label: 'No-shows',
      value: stats?.noShowsCancelledCount ?? 0,
      subtext: `${formatUsdCurrency(stats?.chargedAmount ?? 0)} charged`,
    },
  ];

  return (
    <div className="flex gap-2.4">
      {tiles.map((tile) => (
        <div
          key={tile.label}
          className="flex-1 bg-white rounded-[1rem] border border-light-grey p-2.4 flex flex-col gap-y-1.6 min-h-[10rem]"
        >
          <span className="text-18 leading-[2.7rem] font-bold text-darkest-grey">
            {tile.label}
          </span>
          {isLoading ? (
            <LoadingSpinner className="all-child:fill-magenta w-4 h-4" />
          ) : (
            <>
              <span className="text-30 font-bold text-magenta">
                {tile.value}
              </span>
              <span className="text-14 text-mid-grey">{tile.subtext}</span>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default PaymentStats;
